import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import {
  useGetSendOutCollectionDetailQuery,
  useUpdateSendOutCollectionMutation,
} from "store/services/sendOutCollectionApi"; // <- your Collection API

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { SendOutCollectionDetailContext, useSendOutCollectionDetailContext } from "contexts/SendOutCollectionDetailContext";
import SendOutCollectionBasicDetail from "./SendOutCollectionComponent/SendOutCollectionBasicDetail";
import SendOutCollectionDetailTab from "./SendOutCollectionComponent/SendOutCollectionDetailTab";
import { useAuth } from "hooks";

const SendOutCollectionDetailScreen = () => {
  const { id } = useParams();

  const breadcrumb = [
    { title: "Send Out Collection", path: "/app/crm/sendOutCollection/list" },
    { title: "Send Out Collection Detail" },
  ];

  const {
    data: sendOutCollectionDetail,
    isLoading: loadingSendOutCollection,
    error,
  } = useGetSendOutCollectionDetailQuery(id);

  return (
    <SendOutCollectionDetailContext.Provider value={{ sendOutCollectionDetail, loadingSendOutCollection }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingSendOutCollection}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <SendOutCollectionBasicDetail />
          <Divider/>
          <SendOutCollectionDetailTab/>
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </SendOutCollectionDetailContext.Provider>
  );
};

export default SendOutCollectionDetailScreen;

const PageActions = () => {

 const { isAccountAdmin } = useAuth();

  const { sendOutCollectionDetail, loadingSendOutCollection } = useSendOutCollectionDetailContext();

  const [updateSendOutCollection, { isLoading: updatingSendOutCollection }] = useUpdateSendOutCollectionMutation();

  const handleToggleStatus = async () => {
    try {
      await updateSendOutCollection({
        _id: sendOutCollectionDetail._id,
        isActive: !sendOutCollectionDetail.isActive,
      }).unwrap();
      toast.info(`Send Out Collection ${sendOutCollectionDetail.isActive ? "Disabled" : "Enabled"}!`);
    } catch (error) {
      toast.error(error?.data?.message ?? "Could Not Update Status");
    }
  };

  return (
    <div className="flex space-x-4">
     {isAccountAdmin &&( <EnableDisableButton
        isActive={sendOutCollectionDetail?.isActive}
        loading={loadingSendOutCollection || updatingSendOutCollection}
        onClick={handleToggleStatus}
      />)}

      <Link to={`/app/crm/sendOutCollection/${sendOutCollectionDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
